const translations = {
    ar: {
        nav: {
            home: "الرئيسية",
            branches: "الفروع",
            products: "المنتجات",
            categories: "التصنيفات",
            tiers: "الطبقات",
            challenges: "التحديات",
            adBanners: "الإعلانات",
            customers: "العملاء",
            orders: "الطلبات",
            feedbacks: "التقييمات",
            clients: "المسؤولين",
            settings: "الإعدادات",
            profile: "الملف الشخصي",
        },
        clientMenu: {
            owner: "مالك",
            staff: "موظف",
            settings: "الإعدادات",
            logout: "تسجيل الخروج",
        },
        appBar: {
            search: "بحث",
            notifications: "الإشعارات",
        },
        actionsBar: {
            add: "إضافة",
            filter: "تصفية",
            closeFilter: "إلغاء",
            search: "بحث...",
            saveFilter: "حفظ",
            clearFilter: "مسح",
            cancelFilter: "إلغاء",
        },
        filters: {
            all: "الكل",
            yes: "نعم",
            no: "لا",
            from: "من",
            to: "إلى",
            branches: {
                search: "بحث بالاسم...",
                rateRange: "التقييم",
            },
            products: {
                search: "بحث بالاسم...",
                category: "التصنيف",
                temperature: "الحرارة",
                active: "نشط",
                hidden: "مخفي",
                priceRange: "السعر",
            },
            categories: {
                search: "بحث بالاسم...",
            },
            tiers: {
                search: "بحث بالاسم...",
                startRange: "يبدأ من",
                redeemRange: "معدل الاستبدال",
            },
            challenges: {
                search: "بحث بالاسم...",
                trigger: "المحفز",
                active: "الحالة",
                repeatable: "قابل للتكرار",
                startDate: "تاريخ البدء",
                endDate: "تاريخ الانتهاء",
                beansRange: "حبوب البن",
                tiers: "الطبقات",
            },
            customers: {
                search: "بحث بالاسم...",
                gender: "الجنس",
                status: "الحالة",
                beansRange: "حبوب البن",
                joinDate: "تاريخ الانضمام",
            },
            orders: {
                search: "بحث برقم الطلب...",
                status: "الحالة",
                source: "المصدر",
                branch: "الفرع",
                totalRange: "الإجمالي",
                dateRange: "التاريخ",
            },
            feedbacks: {
                search: "بحث في التعليقات...",
                rateRange: "التقييم",
                hidden: "الحالة",
                branch: "الفرع",
                product: "المنتج",
                dateRange: "التاريخ",
            },
            clients: {
                search: "بحث بالاسم...",
                gender: "الجنس",
            },
        },
        table: {
            empty: "لا توجد عناصر",
            itemsOf: "عناصر من",
            active: "نشط",
            inactive: "غير نشط",
            actions: {
                edit: "تعديل",
                duplicate: "نسخ",
                delete: "حذف",
                view: "عرض",
                hide: "إخفاء",
                unhide: "إظهار",
            },
            viewDetails: "عرض التفاصيل",
            perPage: "لكل صفحة",
        },
        confirmPopup: {
            cancel: "إلغاء",
            confirm: "تأكيد",
        },
        products: {
            col: {
                image: "الصورة",
                name: "الاسم",
                description: "الوصف",
                category: "التصنيف",
                temperature: "الحرارة",
                sizes: "المقاسات",
                sort: "الترتيب",
                active: "نشط",
                hidden: "مخفي",
                discount: "الخصم",
                actions: "",
            },
            temp: {
                hot: "ساخن",
                cold: "بارد",
            },
            deleteConfirm: "هل أنت متأكد من حذف هذا المنتج؟ لا يمكن التراجع عن هذا الإجراء.",
            sortBtn: "ترتيب المنتجات",
            sortPopupTitle: "ترتيب المنتجات",
            sortStep1Hint: "اختر التصنيف الذي تريد ترتيب منتجاته",
            sortStep2Hint: "اسحب المنتجات لإعادة ترتيبها",
            sortConfirm: "حفظ الترتيب",
            sortCancel: "إلغاء",
            sortBack: "رجوع",
            sortReset: "إعادة الضبط",
            sortNoProducts: "لا توجد منتجات في هذا التصنيف",
            sortAll: "جميع المنتجات",
        },
        categories: {
            col: {
                image: "الصورة",
                name: "الاسم",
                description: "الوصف",
                sort: "الترتيب",
                actions: "",
            },
            deleteConfirm: "هل أنت متأكد من حذف هذا التصنيف؟ لا يمكن التراجع عن هذا الإجراء.",
            sortBtn: "ترتيب التصنيفات",
            sortPopupTitle: "ترتيب التصنيفات",
            sortHint: "اسحب التصنيفات لإعادة ترتيبها",
            sortConfirm: "حفظ الترتيب",
            sortCancel: "إلغاء",
            sortReset: "إعادة الضبط",
        },
        branches: {
            col: {
                name: "الاسم",
                address: "العنوان",
                location: "الموقع",
                actions: "",
            },
            hasLocation: "محدد",
            noLocation: "غير محدد",
            deleteConfirm: "هل أنت متأكد من حذف هذا الفرع؟ لا يمكن التراجع عن هذا الإجراء.",
        },
        tiers: {
            col: {
                name: "الاسم",
                description: "الوصف",
                start: "يبدأ من",
                redeemRate: "معدل الاستبدال",
                actions: "",
            },
            beans: "حبة بن",
            deleteConfirm: "هل أنت متأكد من حذف هذه الطبقة؟ لا يمكن التراجع عن هذا الإجراء.",
        },
        tierForm: {
            createTitle: "إضافة طبقة",
            editTitle: "تعديل الطبقة",
            duplicateTitle: "نسخ الطبقة",
            nameSection: "الاسم",
            name: "اسم الطبقة",
            descriptionSection: "الوصف",
            description: "الوصف",
            arabic: "عربي",
            english: "English",
            coffeeBeansSection: "إعدادات حبوب البن",
            start: "يبدأ من كم (حبة بن)",
            redeemRate: "معدل الاستبدال",
            ratesHint: "معدل الاستبدال: عدد حبوب البن اللازمة للحصول على ريال واحد.",
            create: "إنشاء",
            update: "تحديث",
            cancel: "إلغاء",
            nameRequired: "اسم الطبقة مطلوب (عربي أو إنجليزي)",
            ok: "حسناً",
        },
        challenges: {
            col: {
                name: "الاسم",
                description: "الوصف",
                trigger: "المحفز",
                target: "الهدف",
                coffeeBeans: "حبوب البن",
                count: "العدد",
                dateRange: "الفترة الزمنية",
                repeatable: "قابل للتكرار",
                active: "الحالة",
                actions: "",
            },
            triggers: {
                money: "مبلغ مالي",
                order: "طلب",
                product: "منتج",
                category: "فئة",
            },
            beans: "حبة بن",
            yes: "نعم",
            no: "لا",
            active: "نشط",
            inactive: "غير نشط",
            deleteConfirm: "هل أنت متأكد من حذف هذا التحدي؟ لا يمكن التراجع عن هذا الإجراء.",
        },
        challengeForm: {
            createTitle: "إضافة تحدي",
            editTitle: "تعديل التحدي",
            duplicateTitle: "نسخ التحدي",
            nameSection: "الاسم",
            name: "اسم التحدي",
            descriptionSection: "الوصف",
            description: "الوصف",
            arabic: "عربي",
            english: "English",
            configSection: "إعدادات التحدي",
            trigger: "نوع المحفز",
            triggerMoney: "مبلغ مالي",
            triggerOrder: "طلب",
            triggerProduct: "منتج",
            triggerCategory: "فئة",
            selectProduct: "اختر منتجاً",
            selectCategory: "اختر فئة",
            coffeeBeans: "حبوب البن المكتسبة",
            count: "عدد مرات الإتمام",
            dateRange: "الفترة الزمنية",
            startDate: "تاريخ البداية",
            endDate: "تاريخ النهاية",
            days: "عدد الأيام",
            consecutive: "أيام متتالية",
            minPrice: "الحد الأدنى للسعر",
            configHint: "حبوب البن: عدد الحبوب التي يكسبها العميل عند إتمام التحدي. العدد: كم مرة يجب تكرار الفعل لإتمام التحدي.",
            daysHint: "اتركه فارغاً إذا لم يكن التحدي محدداً بعدد أيام",
            minPriceHint: "يطبق فقط على التحديات من نوع (طلب) أو (فئة)",
            optionsSection: "الخيارات",
            repeatable: "قابل للتكرار",
            active: "نشط",
            optionsHint: "قابل للتكرار: يمكن للعميل إعادة التحدي بعد إتمامه. نشط: التحدي متاح للعملاء.",
            create: "إنشاء",
            update: "تحديث",
            cancel: "إلغاء",
            nameRequired: "اسم التحدي مطلوب (عربي أو إنجليزي)",
            triggerRequired: "نوع المحفز مطلوب",
            dateRequired: "تاريخ البداية والنهاية مطلوبان",
            ok: "حسناً",
            choose: "اختيار",
            tiersSection: "الطبقات",
            selectTiers: "اختر الطبقات",
            tiersHint: "اتركه فارغاً لتطبيق التحدي على جميع الطبقات",
        },
        branchForm: {
            createTitle: "إضافة فرع",
            editTitle: "تعديل الفرع",
            duplicateTitle: "نسخ الفرع",
            basicInfo: "المعلومات الأساسية",
            name: "اسم الفرع",
            address: "العنوان",
            arabic: "عربي",
            english: "English",
            locationSection: "الموقع على الخريطة",
            locationHint: "انقر على الخريطة لتحديد موقع الفرع",
            addGoogleMapsUrl: "أضف رابط Google Maps",
            googleMapsPopupTitle: "تحديد الموقع عبر Google Maps",
            googleMapsUrlLabel: "رابط Google Maps",
            googleMapsUrlHint: "افتح الموقع على Google Maps، انسخ الرابط من شريط العنوان والصقه هنا",
            googleMapsUrlShort: "هذا رابط مختصر ولا يحتوي على الإحداثيات مباشرة. افتحه في المتصفح أولاً، ثم انسخ الرابط الكامل من شريط العنوان.",
            googleMapsUrlInvalid: "تعذّر استخراج الإحداثيات من هذا الرابط. تأكد من نسخ الرابط الكامل من شريط العنوان في المتصفح وليس رابطاً مختصراً.",
            googleMapsSubmit: "تحديد الموقع",
            googleMapsCancel: "إلغاء",
            create: "إنشاء",
            update: "تحديث",
            cancel: "إلغاء",
            nameRequired: "اسم الفرع مطلوب (عربي أو إنجليزي)",
            ok: "حسناً",
        },
        categoryForm: {
            createTitle: "إضافة تصنيف",
            editTitle: "تعديل التصنيف",
            duplicateTitle: "نسخ التصنيف",
            name: "الاسم",
            description: "الوصف",
            arabic: "عربي",
            english: "English",
            sort: "الترتيب",
            pictureSection: "الصورة",
            addPicture: "إضافة صورة",
            create: "إنشاء",
            update: "تحديث",
            cancel: "إلغاء",
            nameRequired: "اسم التصنيف مطلوب (عربي أو إنجليزي)",
            ok: "حسناً",
        },
        productForm: {
            createTitle: "إضافة منتج",
            editTitle: "تعديل المنتج",
            duplicateTitle: "نسخ المنتج",
            basicInfo: "المعلومات الأساسية",
            categorization: "التصنيف والترتيب",
            discountSection: "الخصم",
            sizesSection: "المقاسات",
            picturesSection: "الصور",
            name: "الاسم",
            description: "الوصف",
            arabic: "عربي",
            english: "English",
            nameAr: "الاسم بالعربي",
            nameEn: "الاسم بالإنجليزي",
            descriptionAr: "الوصف بالعربي",
            descriptionEn: "الوصف بالإنجليزي",
            temperature: "درجة الحرارة",
            tempNone: "بدون تحديد",
            tempHot: "ساخن",
            tempCold: "بارد",
            category: "التصنيف",
            noCategory: "بدون تصنيف",
            sort: "الترتيب",
            hasDiscount: "خصم",
            discountType: "نوع الخصم",
            discountAmount: "قيمة الخصم",
            discountPercentage: "نسبة مئوية",
            discountFixed: "مبلغ ثابت",
            addSize: "إضافة مقاس",
            addSizeTitle: "إضافة مقاس",
            editSize: "تعديل مقاس",
            deleteSizeConfirm: "هل أنت متأكد من حذف هذا المقاس؟",
            sizeTitle: "عنوان المقاس",
            sizeTitleAr: "عنوان المقاس بالعربي",
            sizeTitleEn: "عنوان المقاس بالإنجليزي",
            sizeShowTitle: "إظهار العنوان",
            sizePrice: "السعر",
            addPicture: "إضافة صورة",
            pictureUrl: "رابط الصورة",
            visibilitySection: "الإتاحة",
            active: "نشط",
            activeHint: "يظهر المنتج في القوائم ويمكن طلبه",
            hidden: "مخفي",
            hiddenHint: "يُخفى المنتج من القوائم العامة",
            create: "إنشاء",
            update: "تحديث",
            cancel: "إلغاء",
            nameRequired: "اسم المنتج مطلوب (عربي أو إنجليزي)",
            ok: "حسناً",
        },
        login: {
            title: "تسجيل الدخول",
            subtitle: "أدخل بياناتك للوصول إلى لوحة التحكم",
            phone: "رقم الهاتف",
            password: "كلمة المرور",
            submit: "دخول",
        },
        selectStore: {
            title: "اختر متجراً",
            subtitle: "اختر المتجر الذي تريد إدارته",
        },
        chooseLang: {
            title: "اختر لغتك",
            subtitle: "Choose your language",
            ar: "العربية",
            en: "English",
        },
        clients: {
            col: {
                picture: "الصورة",
                name: "الاسم",
                phone: "الهاتف",
                role: "الدور",
                scanner: "الماسح الضوئي",
                email: "البريد",
                creating: "إنشاء",
                editing: "تعديل",
                deleting: "حذف",
                viewing: "عرض",
                actions: "",
            },
            owner: "مالك",
            staff: "موظف",
            scanner: "لديه صلاحية",
            deleteConfirm: "هل أنت متأكد من حذف هذا المسؤول لا يمكن التراجع عن هذا الإجراء.",
            models: "نماذج",
        },
        customers: {
            col: {
                picture: "الصورة",
                name: "الاسم",
                phone: "الهاتف",
                email: "البريد",
                gender: "الجنس",
                birthDate: "تاريخ الميلاد",
                coffeeBeans: "حبات البن",
                tier: "الطبقة",
                orders: "الطلبات",
                feedbacks: "التقييمات",
            },
            beans: "حبة بن",
        },
        feedbacks: {
            col: {
                customer: "العميل",
                order: "الطلب",
                product: "المنتج",
                branch: "الفرع",
                rate: "التقييم",
                feedback: "التعليق",
                hidden: "مخفي",
                visible: "ظاهر",
                date: "التاريخ",
                actions: "",
            },
            hiddenText: "******",
        },
        orders: {
            col: {
                number: "رقم الطلب",
                customer: "العميل",
                branch: "الفرع",
                items: "العناصر",
                totalPrice: "الإجمالي",
                status: "الحالة",
                date: "التاريخ",
                actions: "",
            },
            sar: "ريال",
            statuses: {
                completed: "مكتمل",
                pending: "قيد الانتظار",
                rejected: "مرفوض",
                cancelled: "ملغي",
            },
        },
        orderDetails: {
            title: "تفاصيل الطلب",
            loading: "جاري التحميل...",
            customerInfo: "معلومات العميل",
            branchInfo: "معلومات الفرع",
            items: "عناصر الطلب",
            total: "الإجمالي",
            orderInfo: "تفاصيل الطلب",
            orderNumber: "رقم الطلب",
            source: "المصدر",
            date: "التاريخ",
            pickupCode: "كود الاستلام",
            updateStatus: "تحديث الحالة",
            statusLabel: "الحالة",
            save: "حفظ",
            saving: "جاري الحفظ...",
            cancel: "إلغاء",
            sources: {
                customer: "عميل",
                client: "موظف",
                cashier: "كاشير",
            },
        },
        clientForm: {
            createTitle: "إضافة مسؤول",
            editTitle: "تعديل صلاحيات المسؤول",
            duplicateTitle: "نسخ المسؤول",
            basicInfo: "المعلومات الأساسية",
            name: "الاسم",
            phone: "رقم الهاتف",
            ownerSection: "الملكية",
            makeOwner: "جعله مالكاً",
            ownerHint: "المالك لديه جميع الصلاحيات ويمكنه إدارة المسؤولين الآخرين",
            scannerSection: "الماسح الضوئي",
            makeScanner: "تفعيل وصول الماسح",
            scannerHint: "يمكّن هذا المسؤول من تسجيل الدخول إلى تطبيق الماسح الضوئي لهذا المتجر",
            permissionsSection: "الصلاحيات",
            all: "الكل",
            create: "إنشاء",
            update: "تحديث",
            cancel: "إلغاء",
            nameRequired: "اسم المسؤول مطلوب",
            phoneRequired: "رقم الهاتف مطلوب",
            ok: "حسناً",
        },
        permissionPopup: {
            title: "تعديل الصلاحيات",
            model: "النموذج",
            viewing: "عرض",
            creating: "إنشاء",
            editing: "تعديل",
            deleting: "حذف",
            save: "حفظ",
            cancel: "إلغاء",
            models: {
                branches: "الفروع",
                products: "المنتجات",
                tiers: "الطبقات",
                challenges: "التحديات",
                "ad-banners": "الإعلانات",
                clients: "المسؤولين",
            },
        },
        profile: {
            owner: "مالك",
            staff: "موظف",
            permissions: "الصلاحيات",
            editAccount: "تعديل الحساب",
            male: "ذكر",
            female: "أنثى",
            models: {
                branches: "الفروع",
                products: "المنتجات",
                tiers: "الطبقات",
                challenges: "التحديات",
                "ad-banners": "الإعلانات",
                clients: "المسؤولين",
                customers: "العملاء",
                orders: "الطلبات",
            },
            actions: {
                viewing: "عرض",
                creating: "إنشاء",
                editing: "تعديل",
                deleting: "حذف",
            },
        },
        settings: {
            accountSection: "الحساب والأمان:",
            languageSection: "اللغة والتنسيق:",
            passwordSection: "تغيير الرقم السري:",
            changePicture: "تغيير الصورة",
            changeName: "تغيير الاسم:",
            changeEmail: "تغيير الايميل:",
            selectGender: "اختيار الجنس:",
            birthDate: "تاريخ الميلاد:",
            male: "ذكر",
            female: "أنثى",
            selectLanguage: "اختيار اللغة:",
            arabic: "عربي",
            english: "انجليزي",
            password: "الرقم السري:",
            confirmPassword: "تأكيد الرقم السري:",
            saveChanges: "حفظ التغييرات",
            cancel: "إلغاء",
            updateSuccess: "تم تحديث البيانات بنجاح",
            updateError: "حدث خطأ أثناء التحديث",
            passwordMismatch: "كلمات المرور غير متطابقة",
            passwordTooShort: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
            otpSent: "تم إرسال رمز التحقق إلى هاتفك",
        },
        verifyOtp: {
            title: "التحقق من الرمز",
            description: "أدخل الرمز المكون من 4 أرقام المرسل إلى هاتفك",
            verify: "تحقق",
            verifying: "جاري التحقق...",
            cancel: "إلغاء",
            successMessage: "تم تغيير كلمة المرور بنجاح",
        },
        adBanners: {
            overviewTitle: "أظهر متجرك على الشاشة الرئيسية",
            overviewDesc: "احصل على مساحة إعلانية مميزة على شاشة التطبيق الرئيسية وابدأ في استقطاب المزيد من العملاء.",
            step1Label: "أرسل طلبك",
            step1Desc: "أرسل طلبك مع تفاصيل ما تريده من إعلانك",
            step2Label: "نتواصل معك",
            step2Desc: "يتواصل فريقنا معك على الواتساب لإنهاء التفاصيل",
            step3Label: "إعلانك يعمل",
            step3Desc: "بعد التأكيد يظهر إعلانك لعملاء التطبيق",
            requestBtn: "أرسل طلب إعلان",
            currentTitle: "طلبك الحالي",
            statusLabel: "الحالة",
            messageLabel: "وصف الطلب",
            whatsappLabel: "رقم الواتساب",
            typeLabel: "النوع",
            startDateLabel: "تاريخ البدء المقترح",
            endDateLabel: "تاريخ الانتهاء المقترح",
            responseLabel: "رد الإدارة",
            bannerLabel: "الإعلان",
            cancelBtn: "إلغاء الطلب",
            cancelConfirm: "هل أنت متأكد من إلغاء هذا الطلب؟",
            status: {
                sending: "قيد الإرسال",
                reviewing: "قيد المراجعة",
                accepted: "مقبول",
                rejected: "مرفوض",
            },
            types: {
                product: "منتج",
                store: "متجرنا",
                menu: "قائمتنا",
                external: "رابط خارجي",
                none: "غير محدد",
            },
            formTitle: "طلب إعلان جديد",
            formMessage: "وصف الإعلان",
            formMessageHint: "اشرح ما تريده من الإعلان، والمنتجات أو العروض التي تريد إبرازها",
            formWhatsapp: "رقم الواتساب للتواصل",
            formType: "نوع الإعلان",
            formTypeNone: "اختر نوعاً",
            typeRequired: "نوع الإعلان مطلوب",
            formStartDate: "تاريخ البدء المقترح (اختياري)",
            formEndDate: "تاريخ الانتهاء المقترح (اختياري)",
            formSubmit: "إرسال الطلب",
            formCancel: "إلغاء",
            messageRequired: "وصف الإعلان مطلوب",
            whatsappRequired: "رقم الواتساب مطلوب",
        },
        homeScreen: {
            live: "نشط",
            title: "متجرك يعمل بكامل طاقته",
            subtitle: "كل ما تحتاجه لإدارة متجرك جاهز ومتاح الآن",
        },
        placeholders: {
            home: "الرئيسية",
            branches: "الفروع",
            products: "المنتجات",
            tiers: "الطبقات",
            challenges: "التحديات",
            adBanners: "الإعلانات",
            clients: "المسؤولين",
            settings: "الإعدادات",
            profile: "الملف الشخصي",
        },
    },
    en: {
        nav: {
            home: "Home",
            branches: "Branches",
            products: "Products",
            categories: "Categories",
            tiers: "Tiers",
            challenges: "Challenges",
            adBanners: "Ad Banners",
            customers: "Customers",
            orders: "Orders",
            feedbacks: "Feedbacks",
            clients: "Clients",
            settings: "Settings",
            profile: "Profile",
        },
        clientMenu: {
            owner: "Owner",
            staff: "Staff",
            settings: "Settings",
            logout: "Logout",
        },
        appBar: {
            search: "Search",
            notifications: "Notifications",
        },
        actionsBar: {
            add: "Add",
            filter: "Filter",
            closeFilter: "Cancel",
            search: "Search...",
            saveFilter: "Save",
            clearFilter: "Clear",
            cancelFilter: "Cancel",
        },
        filters: {
            all: "All",
            yes: "Yes",
            no: "No",
            from: "From",
            to: "To",
            branches: {
                search: "Search by name...",
                rateRange: "Rating",
            },
            products: {
                search: "Search by name...",
                category: "Category",
                temperature: "Temperature",
                active: "Active",
                hidden: "Hidden",
                priceRange: "Price",
            },
            categories: {
                search: "Search by name...",
            },
            tiers: {
                search: "Search by name...",
                startRange: "Starts At",
                redeemRange: "Redeem Rate",
            },
            challenges: {
                search: "Search by name...",
                trigger: "Trigger",
                active: "Status",
                repeatable: "Repeatable",
                startDate: "Start Date",
                endDate: "End Date",
                beansRange: "Coffee Beans",
                tiers: "Tiers",
            },
            customers: {
                search: "Search by name...",
                gender: "Gender",
                status: "Status",
                beansRange: "Coffee Beans",
                joinDate: "Join Date",
            },
            orders: {
                search: "Search by order #...",
                status: "Status",
                source: "Source",
                branch: "Branch",
                totalRange: "Total",
                dateRange: "Date",
            },
            feedbacks: {
                search: "Search in feedback...",
                rateRange: "Rating",
                hidden: "Visibility",
                branch: "Branch",
                product: "Product",
                dateRange: "Date",
            },
            clients: {
                search: "Search by name...",
                gender: "Gender",
            },
        },
        table: {
            empty: "No items found",
            itemsOf: "items of",
            active: "Active",
            inactive: "Inactive",
            actions: {
                edit: "Edit",
                duplicate: "Duplicate",
                delete: "Delete",
                view: "View",
                hide: "Hide",
                unhide: "Unhide",
            },
            viewDetails: "View Details",
            perPage: "per page",
        },
        confirmPopup: {
            cancel: "Cancel",
            confirm: "Confirm",
        },
        products: {
            col: {
                image: "Image",
                name: "Name",
                description: "Description",
                category: "Category",
                temperature: "Temperature",
                sizes: "Sizes",
                sort: "Sort",
                active: "Active",
                hidden: "Hidden",
                discount: "Discount",
                actions: "",
            },
            temp: {
                hot: "Hot",
                cold: "Cold",
            },
            deleteConfirm: "Are you sure you want to delete this product? This action cannot be undone.",
            sortBtn: "Sort Products",
            sortPopupTitle: "Sort Products",
            sortStep1Hint: "Choose a category to sort its products",
            sortStep2Hint: "Drag products to reorder them",
            sortConfirm: "Save Order",
            sortCancel: "Cancel",
            sortBack: "Back",
            sortReset: "Reset",
            sortNoProducts: "No products in this category",
            sortAll: "All Products",
        },
        categories: {
            col: {
                image: "Image",
                name: "Name",
                description: "Description",
                sort: "Sort",
                actions: "",
            },
            deleteConfirm: "Are you sure you want to delete this category? This action cannot be undone.",
            sortBtn: "Sort Categories",
            sortPopupTitle: "Sort Categories",
            sortHint: "Drag categories to reorder them",
            sortConfirm: "Save Order",
            sortCancel: "Cancel",
            sortReset: "Reset",
        },
        branches: {
            col: {
                name: "Name",
                address: "Address",
                location: "Location",
                actions: "",
            },
            hasLocation: "Set",
            noLocation: "Not set",
            deleteConfirm: "Are you sure you want to delete this branch? This action cannot be undone.",
        },
        tiers: {
            col: {
                name: "Name",
                description: "Description",
                start: "Starts At",
                redeemRate: "Redeem Rate",
                actions: "",
            },
            deleteConfirm: "Are you sure you want to delete this tier? This action cannot be undone.",
        },
        tierForm: {
            createTitle: "Add Tier",
            editTitle: "Edit Tier",
            duplicateTitle: "Duplicate Tier",
            nameSection: "Name",
            name: "Tier Name",
            descriptionSection: "Description",
            description: "Description",
            arabic: "عربي",
            english: "English",
            coffeeBeansSection: "Coffee Beans Config",
            start: "Starts At (coffee-beans)",
            redeemRate: "Redeem Rate",
            ratesHint: "Redeem Rate: number of coffee beans needed to earn 1 SAR.",
            create: "Create",
            update: "Update",
            cancel: "Cancel",
            nameRequired: "Tier name is required (Arabic or English)",
            ok: "OK",
        },
        challenges: {
            col: {
                name: "Name",
                description: "Description",
                trigger: "Trigger",
                target: "Target",
                coffeeBeans: "Coffee Beans",
                count: "Count",
                dateRange: "Date Range",
                repeatable: "Repeatable",
                active: "Status",
                actions: "",
            },
            triggers: {
                money: "Money",
                order: "Order",
                product: "Product",
                category: "Category",
            },
            pts: "pts",
            beans: "beans",
            yes: "Yes",
            no: "No",
            active: "Active",
            inactive: "Inactive",
            deleteConfirm: "Are you sure you want to delete this challenge? This action cannot be undone.",
        },
        challengeForm: {
            createTitle: "Add Challenge",
            editTitle: "Edit Challenge",
            duplicateTitle: "Duplicate Challenge",
            nameSection: "Name",
            name: "Challenge Name",
            descriptionSection: "Description",
            description: "Description",
            arabic: "عربي",
            english: "English",
            configSection: "Challenge Configuration",
            trigger: "Trigger Type",
            triggerMoney: "Money",
            triggerOrder: "Order",
            triggerProduct: "Product",
            triggerCategory: "Category",
            selectProduct: "Select a Product",
            selectCategory: "Select a Category",
            coffeeBeans: "Coffee Beans Reward",
            count: "Completion Count",
            dateRange: "Date Range",
            startDate: "Start Date",
            endDate: "End Date",
            days: "Number of Days",
            consecutive: "Consecutive Days",
            minPrice: "Minimum Price",
            configHint: "Coffee Beans: number of beans earned upon completion. Count: how many times the action must be performed.",
            daysHint: "Leave empty if the challenge is not day-based",
            minPriceHint: "Applies only to order or category trigger types",
            optionsSection: "Options",
            repeatable: "Repeatable",
            active: "Active",
            optionsHint: "Repeatable: customer can redo the challenge after completion. Active: challenge is available to customers.",
            create: "Create",
            update: "Update",
            cancel: "Cancel",
            nameRequired: "Challenge name is required (Arabic or English)",
            triggerRequired: "Trigger type is required",
            dateRequired: "Start date and end date are required",
            ok: "OK",
            choose: "Choose",
            tiersSection: "Tiers",
            selectTiers: "Select Tiers",
            tiersHint: "Leave empty to apply the challenge to all tiers",
        },
        branchForm: {
            createTitle: "Add Branch",
            editTitle: "Edit Branch",
            duplicateTitle: "Duplicate Branch",
            basicInfo: "Basic Info",
            name: "Branch Name",
            address: "Address",
            arabic: "عربي",
            english: "English",
            locationSection: "Location on Map",
            locationHint: "Click on the map to set the branch location",
            addGoogleMapsUrl: "Add Google Maps URL",
            googleMapsPopupTitle: "Set Location via Google Maps",
            googleMapsUrlLabel: "Google Maps URL",
            googleMapsUrlHint: "Open the location in Google Maps, then copy the full URL from the browser's address bar and paste it here",
            googleMapsUrlShort:
                "This is a shortened link and doesn't contain coordinates directly. Open it in your browser first, then copy the full URL from the address bar.",
            googleMapsUrlInvalid:
                "Couldn't extract coordinates from this URL. Make sure you copy the full URL from the browser's address bar, not a shortened link.",
            googleMapsSubmit: "Set Location",
            googleMapsCancel: "Cancel",
            create: "Create",
            update: "Update",
            cancel: "Cancel",
            nameRequired: "Branch name is required (Arabic or English)",
            ok: "OK",
        },
        categoryForm: {
            createTitle: "Add Category",
            editTitle: "Edit Category",
            duplicateTitle: "Duplicate Category",
            name: "Name",
            description: "Description",
            arabic: "عربي",
            english: "English",
            sort: "Sort Order",
            pictureSection: "Picture",
            addPicture: "Add Picture",
            create: "Create",
            update: "Update",
            cancel: "Cancel",
            nameRequired: "Category name is required (Arabic or English)",
            ok: "OK",
        },
        productForm: {
            createTitle: "Add Product",
            editTitle: "Edit Product",
            duplicateTitle: "Duplicate Product",
            basicInfo: "Basic Info",
            categorization: "Category & Sort",
            discountSection: "Discount",
            sizesSection: "Sizes",
            picturesSection: "Pictures",
            name: "Name",
            description: "Description",
            arabic: "عربي",
            english: "English",
            nameAr: "Name (Arabic)",
            nameEn: "Name (English)",
            descriptionAr: "Description (Arabic)",
            descriptionEn: "Description (English)",
            temperature: "Temperature",
            tempNone: "Not specified",
            tempHot: "Hot",
            tempCold: "Cold",
            category: "Category",
            noCategory: "No Category",
            sort: "Sort Order",
            hasDiscount: "Discount",
            discountType: "Discount Type",
            discountAmount: "Amount",
            discountPercentage: "Percentage",
            discountFixed: "Fixed Amount",
            addSize: "Add Size",
            addSizeTitle: "Add Size",
            editSize: "Edit Size",
            deleteSizeConfirm: "Are you sure you want to delete this size?",
            sizeTitle: "Size Title",
            sizeTitleAr: "Title (Arabic)",
            sizeTitleEn: "Title (English)",
            sizeShowTitle: "Show Title",
            sizePrice: "Price",
            addPicture: "Add Picture",
            pictureUrl: "Picture URL",
            visibilitySection: "Availability",
            active: "Active",
            activeHint: "Product appears in listings and can be ordered",
            hidden: "Hidden",
            hiddenHint: "Product is hidden from public listings",
            create: "Create",
            update: "Update",
            cancel: "Cancel",
            nameRequired: "Product name is required (Arabic or English)",
            ok: "OK",
        },
        login: {
            title: "Sign In",
            subtitle: "Enter your credentials to access the dashboard",
            phone: "Phone Number",
            password: "Password",
            submit: "Sign In",
        },
        selectStore: {
            title: "Select a Store",
            subtitle: "Choose the store you want to manage",
        },
        chooseLang: {
            title: "اختر لغتك",
            subtitle: "Choose your language",
            ar: "العربية",
            en: "English",
        },
        clients: {
            col: {
                picture: "Picture",
                name: "Name",
                phone: "Phone",
                role: "Role",
                scanner: "Scanner",
                email: "Email",
                creating: "Creating",
                editing: "Editing",
                deleting: "Deleting",
                viewing: "Viewing",
                actions: "",
            },
            owner: "Owner",
            staff: "Staff",
            scanner: "Has Access",
            deleteConfirm: "Are you sure you want to delete this client? This action cannot be undone.",
            models: "models",
        },
        customers: {
            col: {
                picture: "Picture",
                name: "Name",
                phone: "Phone",
                email: "Email",
                gender: "Gender",
                birthDate: "Birth Date",
                coffeeBeans: "Coffee Beans",
                tier: "Tier",
                orders: "Orders",
                feedbacks: "Feedbacks",
            },
            beans: "coffee beans",
        },
        feedbacks: {
            col: {
                customer: "Customer",
                order: "Order",
                product: "Product",
                branch: "Branch",
                rate: "Rate",
                feedback: "Feedback",
                hidden: "Hidden",
                visible: "Visible",
                date: "Date",
                actions: "",
            },
            hiddenText: "******",
        },
        orders: {
            col: {
                number: "Order #",
                customer: "Customer",
                branch: "Branch",
                items: "Items",
                totalPrice: "Total",
                status: "Status",
                date: "Date",
                actions: "",
            },
            sar: "SAR",
            statuses: {
                completed: "Completed",
                pending: "Pending",
                rejected: "Rejected",
                cancelled: "Cancelled",
            },
        },
        orderDetails: {
            title: "Order Details",
            loading: "Loading...",
            customerInfo: "Customer Information",
            branchInfo: "Branch Information",
            items: "Order Items",
            total: "Total",
            orderInfo: "Order Information",
            orderNumber: "Order Number",
            source: "Source",
            date: "Date",
            pickupCode: "Pickup Code",
            updateStatus: "Update Status",
            statusLabel: "Status",
            save: "Save",
            saving: "Saving...",
            cancel: "Cancel",
            sources: {
                customer: "Customer",
                client: "Staff",
                cashier: "Cashier",
            },
        },
        clientForm: {
            createTitle: "Add Client",
            editTitle: "Edit Client Permissions",
            duplicateTitle: "Duplicate Client",
            basicInfo: "Basic Info",
            name: "Name",
            phone: "Phone Number",
            ownerSection: "Ownership",
            makeOwner: "Make Owner",
            ownerHint: "Owners have full access and can manage other clients",
            scannerSection: "Scanner Access",
            makeScanner: "Enable Scanner Access",
            scannerHint: "Allows this client to log into the scanner app for this store",
            permissionsSection: "Permissions",
            all: "All",
            create: "Create",
            update: "Update",
            cancel: "Cancel",
            nameRequired: "Client name is required",
            phoneRequired: "Phone number is required",
            ok: "OK",
        },
        permissionPopup: {
            title: "Edit Permissions",
            model: "Model",
            viewing: "Viewing",
            creating: "Creating",
            editing: "Editing",
            deleting: "Deleting",
            save: "Save",
            cancel: "Cancel",
            models: {
                branches: "Branches",
                products: "Products",
                tiers: "Tiers",
                challenges: "Challenges",
                "ad-banners": "Ad Banners",
                clients: "Clients",
            },
        },
        profile: {
            owner: "Owner",
            staff: "Staff",
            permissions: "Permissions",
            editAccount: "Edit Account",
            male: "Male",
            female: "Female",
            models: {
                branches: "Branches",
                products: "Products",
                tiers: "Tiers",
                challenges: "Challenges",
                "ad-banners": "Ad Banners",
                clients: "Clients",
                customers: "Customers",
                orders: "Orders",
            },
            actions: {
                viewing: "View",
                creating: "Create",
                editing: "Edit",
                deleting: "Delete",
            },
        },
        settings: {
            accountSection: "Account & Security:",
            languageSection: "Language & Format:",
            passwordSection: "Change Password:",
            changePicture: "Change Picture",
            changeName: "Change Name:",
            changeEmail: "Change Email:",
            selectGender: "Select Gender:",
            birthDate: "Birth Date:",
            male: "Male",
            female: "Female",
            selectLanguage: "Select Language:",
            arabic: "Arabic",
            english: "English",
            password: "Password:",
            confirmPassword: "Confirm Pass:",
            saveChanges: "Save Changes",
            cancel: "Cancel",
            updateSuccess: "Profile updated successfully",
            updateError: "Error updating profile",
            passwordMismatch: "Passwords do not match",
            passwordTooShort: "Password must be at least 6 characters",
            otpSent: "Verification code sent to your phone",
        },
        verifyOtp: {
            title: "Verify Code",
            description: "Enter the 4-digit code sent to your phone",
            verify: "Verify",
            verifying: "Verifying...",
            cancel: "Cancel",
            successMessage: "Password changed successfully",
        },
        adBanners: {
            overviewTitle: "Advertise on the App's Home Screen",
            overviewDesc: "Get a featured ad spot on the app's main screen and start attracting more customers.",
            step1Label: "Send Your Request",
            step1Desc: "Submit a request with the details of what you'd like in your ad",
            step2Label: "We'll Contact You",
            step2Desc: "Our team will reach out on WhatsApp to finalize the details",
            step3Label: "Your Ad Goes Live",
            step3Desc: "After confirmation, your ad will be visible to app users",
            requestBtn: "Request an Ad",
            currentTitle: "Your Current Request",
            statusLabel: "Status",
            messageLabel: "Request Description",
            whatsappLabel: "WhatsApp Number",
            typeLabel: "Type",
            startDateLabel: "Intended Start Date",
            endDateLabel: "Intended End Date",
            responseLabel: "Admin Response",
            bannerLabel: "Your Banner",
            cancelBtn: "Cancel Request",
            cancelConfirm: "Are you sure you want to cancel this request?",
            status: {
                sending: "Sending",
                reviewing: "Under Review",
                accepted: "Accepted",
                rejected: "Rejected",
            },
            types: {
                product: "Product",
                store: "Our Store",
                menu: "Our Menu",
                external: "External Link",
                none: "Not Specified",
            },
            formTitle: "New Ad Request",
            formMessage: "Ad Description",
            formMessageHint: "Describe what you'd like in your ad, including any products or promotions to highlight",
            formWhatsapp: "WhatsApp Contact Number",
            formType: "Ad Type",
            formTypeNone: "Select a type",
            typeRequired: "Ad type is required",
            formStartDate: "Intended Start Date (Optional)",
            formEndDate: "Intended End Date (Optional)",
            formSubmit: "Submit Request",
            formCancel: "Cancel",
            messageRequired: "Ad description is required",
            whatsappRequired: "WhatsApp number is required",
        },
        homeScreen: {
            live: "Live",
            title: "Your store is up and running",
            subtitle: "Everything you need to manage your store is ready — this screen is the only thing we're still cooking for you.",
        },
        placeholders: {
            home: "Home",
            branches: "Branches",
            products: "Products",
            tiers: "Tiers",
            challenges: "Challenges",
            adBanners: "Ad Banners",
            clients: "Clients",
            settings: "Settings",
            profile: "Profile",
        },
    },
};

export default translations;
